import { LandingApp } from './landing';

// ==============================|| LANDING ROUTE CATALOG (LAND-CFG) ||============================== //
// Her SPA'nın SEÇİLEBİLİR açılış sayfaları. PAYLAŞILAN pakette, çünkü iki taraf da okur:
//   * sahibi olan SPA — kendi açılışını çözmek için (LandingRedirect),
//   * admin ayar ekranı — ÜÇ SPA için de açılır liste göstermek için.
// Ayrı yerlerde tutulsa kaçınılmaz olarak birbirinden ayrışırdı: admin var olmayan bir yolu
// önerebilir ya da SPA yeni bir sayfayı listeye eklemeyi unuturdu.
//
// NEDEN KÜRATÖRLÜ LİSTE (serbest metin değil): route tablosunda olmayan bir yol `*` catch-all'ına
// düşer, catch-all da açılışa döner → GİRİŞTE SONSUZ YÖNLENDİRME. Ayrıca parametreli (/courses/:id)
// ve akış-içi (/checkout, /attempts/:id) sayfalar açılış olarak anlamsızdır.
//
// ETİKETLER ADMIN KATALOĞUNDA: dropdown'u yalnız admin çizer, dolayısıyla labelId'ler
// apps/admin/src/locales/*.json içinde yaşar. Sahibi olan SPA yalnız `path` kullanır, etiket bilmez.
//
// `permission` / `module`: menü gizlemeyle AYNI semantik (filterMenuByPermissions). resolveLandingRoute
// erişilemeyen bir hedefte varsayılana düşer — yoksa kiracı yöneticisi tüm kullanıcıları 403 gördükleri
// bir sayfaya kilitleyebilirdi.

export type LandingRouteOption = {
  path: string;
  /** i18n anahtarı (admin kataloğu). */
  labelId: string;
  /** formatjs'in çıkarabilmesi için varsayılan metin. */
  defaultLabel: string;
  permission?: string;
  /** {service}.{module} — modül üzerinde HERHANGİ bir eylem yeterli (PA-7). */
  module?: string;
};

export type LandingCatalogEntry = {
  /** SPA'nın kendi route tablosundaki SABİT varsayılanı — ayar yok/geçersizse buraya döner. */
  default: string;
  options: readonly LandingRouteOption[];
};

/**
 * ⚠ `default` değerleri her SPA'nın routes dosyasındaki değerle BİREBİR aynı olmalı ve seçenek
 * listesinde YER ALMALI (testle sabitlendi) — aksi halde "varsayılan" seçeneği dropdown'da hiç
 * görünmez ve yönetici eski haline dönemez.
 */
export const LANDING_CATALOG: Readonly<Record<LandingApp, LandingCatalogEntry>> = {
  admin: {
    default: '/dashboard',
    options: [
      { path: '/dashboard', labelId: 'landing-admin-dashboard', defaultLabel: 'Panel' },
      { path: '/education/courses', labelId: 'landing-admin-courses', defaultLabel: 'Dersler' },
      { path: '/education/events', labelId: 'landing-admin-events', defaultLabel: 'Etkinlikler' },
      { path: '/education/enrollments', labelId: 'landing-admin-enrollments', defaultLabel: 'Kayıtlar' },
      { path: '/education/exams', labelId: 'landing-admin-exams', defaultLabel: 'Sınavlar' },
      { path: '/education/grading', labelId: 'landing-admin-grading', defaultLabel: 'Puanlama' },
      { path: '/education/attendance', labelId: 'landing-admin-attendance', defaultLabel: 'Yoklama' }
    ]
  },
  student: {
    // v2 D1: the home page is the default; a tenant that configured a landing keeps it (the setting wins)
    default: '/home',
    options: [
      { path: '/home', labelId: 'landing-student-home', defaultLabel: 'Ana sayfa' },
      { path: '/my-courses', labelId: 'landing-student-my-courses', defaultLabel: 'Derslerim' },
      { path: '/courses', labelId: 'landing-student-courses', defaultLabel: 'Ders kataloğu' },
      { path: '/store', labelId: 'landing-student-store', defaultLabel: 'Mağaza' },
      { path: '/events', labelId: 'landing-student-events', defaultLabel: 'Etkinlikler' },
      { path: '/exams', labelId: 'landing-student-exams', defaultLabel: 'Sınavlar' },
      { path: '/appointments', labelId: 'landing-student-appointments', defaultLabel: 'Randevular' },
      { path: '/inbox', labelId: 'landing-student-inbox', defaultLabel: 'Gelen kutusu' }
    ]
  },
  teacher: {
    default: '/my-courses',
    options: [
      { path: '/my-courses', labelId: 'landing-teacher-my-courses', defaultLabel: 'Derslerim' },
      { path: '/grading', labelId: 'landing-teacher-grading', defaultLabel: 'Puanlama' },
      { path: '/events', labelId: 'landing-teacher-events', defaultLabel: 'Etkinlikler' },
      { path: '/appointments', labelId: 'landing-teacher-appointments', defaultLabel: 'Randevular' },
      { path: '/messages', labelId: 'landing-teacher-messages', defaultLabel: 'Mesajlar' }
    ]
  }
};

/** resolveLandingRoute'un beklediği düz yol listesi. */
export function landingPathsOf(app: LandingApp): readonly string[] {
  return LANDING_CATALOG[app].options.map((o) => o.path);
}

export function landingOptionOf(app: LandingApp, path: string): LandingRouteOption | undefined {
  return LANDING_CATALOG[app].options.find((o) => o.path === path);
}
